/**
 * Created by shubham on 22/5/18.
 */

import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { Http} from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivateDeactivateComponent } from '../activate-deactivate-request/activate-deactivate.component';
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from 'ng2-translate';
import { APPCONFIG } from '../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+APPCONFIG.translationUrl, '?v='+APPCONFIG.translationVersion),
            deps: [Http]
        })
    ],
    declarations: [
        ActivateDeactivateComponent
    ],
    exports: [
        ActivateDeactivateComponent,
    ]
})

export class ActivateDeactivateModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/activate-deactivate-request/activate-deactivate-request.module.ts